// Mock data for E2-Tracking Hospital

export const ASSET_TYPES = [
  { value: 'bed', label: 'Bed', icon: 'bed' },
  { value: 'wheelchair', label: 'Wheelchair', icon: 'accessibility' },
  { value: 'pump', label: 'Infusion Pump', icon: 'droplet' },
  { value: 'trolley', label: 'Medical Trolley', icon: 'shopping-cart' }
];

export const ASSET_STATUSES = [
  { value: 'ready', label: 'Ready', color: '#10B981' },
  { value: 'in-use', label: 'In Use', color: '#3B82F6' },
  { value: 'to-clean', label: 'To Clean', color: '#F59E0B' },
  { value: 'out-of-order', label: 'Out of Order', color: '#EF4444' }
];

export const FLOORS = [
  { id: 0, name: 'Floor 0', department: 'Emergency' },
  { id: 1, name: 'Floor 1', department: 'Surgery' },
  { id: 2, name: 'Floor 2', department: 'Cardiology' }
];

// Floor layouts with rooms
export const FLOOR_LAYOUTS = {
  0: {
    name: 'Emergency',
    rooms: [
      { id: 'E-101', name: 'Triage', x: 50, y: 50, width: 120, height: 80 },
      { id: 'E-102', name: 'ER Room 1', x: 200, y: 50, width: 100, height: 80 },
      { id: 'E-103', name: 'ER Room 2', x: 320, y: 50, width: 100, height: 80 },
      { id: 'E-104', name: 'Trauma Bay', x: 440, y: 50, width: 140, height: 80 },
      { id: 'E-105', name: 'Observation', x: 50, y: 160, width: 150, height: 100 },
      { id: 'E-106', name: 'X-Ray', x: 220, y: 160, width: 120, height: 100 },
      { id: 'E-107', name: 'CT Scan', x: 360, y: 160, width: 120, height: 100 },
      { id: 'E-108', name: 'Waiting Area', x: 500, y: 160, width: 80, height: 100 }
    ],
    corridors: [
      { x: 50, y: 140, width: 530, height: 10 },
      { x: 180, y: 50, width: 10, height: 210 }
    ]
  },
  1: {
    name: 'Surgery',
    rooms: [
      { id: 'S-201', name: 'OR 1', x: 50, y: 50, width: 110, height: 90 },
      { id: 'S-202', name: 'OR 2', x: 180, y: 50, width: 110, height: 90 },
      { id: 'S-203', name: 'OR 3', x: 310, y: 50, width: 110, height: 90 },
      { id: 'S-204', name: 'OR 4', x: 440, y: 50, width: 110, height: 90 },
      { id: 'S-205', name: 'Pre-Op', x: 50, y: 160, width: 130, height: 100 },
      { id: 'S-206', name: 'Post-Op', x: 200, y: 160, width: 130, height: 100 },
      { id: 'S-207', name: 'Sterilization', x: 350, y: 160, width: 100, height: 100 },
      { id: 'S-208', name: 'Storage', x: 470, y: 160, width: 80, height: 100 }
    ],
    corridors: [
      { x: 50, y: 150, width: 500, height: 10 },
      { x: 160, y: 50, width: 10, height: 210 }
    ]
  },
  2: {
    name: 'Cardiology',
    rooms: [
      { id: 'C-301', name: 'Cath Lab 1', x: 50, y: 50, width: 130, height: 90 },
      { id: 'C-302', name: 'Cath Lab 2', x: 200, y: 50, width: 130, height: 90 },
      { id: 'C-303', name: 'Echo Room', x: 350, y: 50, width: 110, height: 90 },
      { id: 'C-304', name: 'Stress Test', x: 480, y: 50, width: 100, height: 90 },
      { id: 'C-305', name: 'CCU 1', x: 50, y: 160, width: 100, height: 100 },
      { id: 'C-306', name: 'CCU 2', x: 170, y: 160, width: 100, height: 100 },
      { id: 'C-307', name: 'CCU 3', x: 290, y: 160, width: 100, height: 100 },
      { id: 'C-308', name: 'Monitoring', x: 410, y: 160, width: 170, height: 100 }
    ],
    corridors: [
      { x: 50, y: 150, width: 530, height: 10 },
      { x: 180, y: 50, width: 10, height: 210 }
    ]
  }
};

// Mock assets
export const MOCK_ASSETS = [
  // Floor 0 - Emergency
  {
    id: 'A001',
    name: 'Bed E-01',
    type: 'bed',
    floor: 0,
    room: 'E-102',
    x: 230,
    y: 70,
    status: 'in-use',
    batteryLevel: 85,
    lastSeen: new Date(Date.now() - 5 * 60000).toISOString(),
    maintenanceTickets: [],
    path: [
      { x: 230, y: 70, timestamp: Date.now() - 7200000 },
      { x: 250, y: 80, timestamp: Date.now() - 3600000 },
      { x: 230, y: 70, timestamp: Date.now() }
    ]
  },
  {
    id: 'A002',
    name: 'Wheelchair E-01',
    type: 'wheelchair',
    floor: 0,
    room: 'E-105',
    x: 100,
    y: 200,
    status: 'ready',
    batteryLevel: 92,
    lastSeen: new Date(Date.now() - 15 * 60000).toISOString(),
    maintenanceTickets: [],
    path: [
      { x: 520, y: 200, timestamp: Date.now() - 7200000 },
      { x: 300, y: 180, timestamp: Date.now() - 5000000 },
      { x: 100, y: 200, timestamp: Date.now() }
    ]
  },
  {
    id: 'A003',
    name: 'Pump E-01',
    type: 'pump',
    floor: 0,
    room: 'E-103',
    x: 350,
    y: 75,
    status: 'in-use',
    batteryLevel: 45,
    lastSeen: new Date(Date.now() - 2 * 60000).toISOString(),
    maintenanceTickets: [],
    path: [
      { x: 350, y: 75, timestamp: Date.now() - 7200000 },
      { x: 360, y: 80, timestamp: Date.now() - 3600000 },
      { x: 350, y: 75, timestamp: Date.now() }
    ]
  },
  {
    id: 'A004',
    name: 'Trolley E-01',
    type: 'trolley',
    floor: 0,
    room: 'E-104',
    x: 490,
    y: 80,
    status: 'ready',
    batteryLevel: 78,
    lastSeen: new Date(Date.now() - 10 * 60000).toISOString(),
    maintenanceTickets: [],
    path: [
      { x: 490, y: 80, timestamp: Date.now() }
    ]
  },
  {
    id: 'A005',
    name: 'Bed E-02',
    type: 'bed',
    floor: 0,
    room: 'E-105',
    x: 120,
    y: 210,
    status: 'to-clean',
    batteryLevel: 67,
    lastSeen: new Date(Date.now() - 30 * 60000).toISOString(),
    maintenanceTickets: [],
    path: [
      { x: 120, y: 210, timestamp: Date.now() }
    ]
  },
  // Floor 1 - Surgery
  {
    id: 'A006',
    name: 'Bed S-01',
    type: 'bed',
    floor: 1,
    room: 'S-205',
    x: 100,
    y: 200,
    status: 'ready',
    batteryLevel: 88,
    lastSeen: new Date(Date.now() - 8 * 60000).toISOString(),
    maintenanceTickets: [],
    path: [
      { x: 100, y: 200, timestamp: Date.now() }
    ]
  },
  {
    id: 'A007',
    name: 'Pump S-01',
    type: 'pump',
    floor: 1,
    room: 'S-201',
    x: 95,
    y: 85,
    status: 'in-use',
    batteryLevel: 72,
    lastSeen: new Date(Date.now() - 3 * 60000).toISOString(),
    maintenanceTickets: [],
    path: [
      { x: 95, y: 85, timestamp: Date.now() }
    ]
  },
  {
    id: 'A008',
    name: 'Trolley S-01',
    type: 'trolley',
    floor: 1,
    room: 'S-202',
    x: 220,
    y: 90,
    status: 'ready',
    batteryLevel: 91,
    lastSeen: new Date(Date.now() - 5 * 60000).toISOString(),
    maintenanceTickets: [],
    path: [
      { x: 380, y: 200, timestamp: Date.now() - 7200000 },
      { x: 250, y: 100, timestamp: Date.now() - 3600000 },
      { x: 220, y: 90, timestamp: Date.now() }
    ]
  },
  {
    id: 'A009',
    name: 'Wheelchair S-01',
    type: 'wheelchair',
    floor: 1,
    room: 'S-206',
    x: 250,
    y: 200,
    status: 'in-use',
    batteryLevel: 55,
    lastSeen: new Date(Date.now() - 12 * 60000).toISOString(),
    maintenanceTickets: [],
    path: [
      { x: 250, y: 200, timestamp: Date.now() }
    ]
  },
  {
    id: 'A010',
    name: 'Pump S-02',
    type: 'pump',
    floor: 1,
    room: 'S-203',
    x: 350,
    y: 85,
    status: 'out-of-order',
    batteryLevel: 12,
    lastSeen: new Date(Date.now() - 120 * 60000).toISOString(),
    maintenanceTickets: [
      {
        id: 'T001',
        status: 'open',
        description: 'Display not working',
        createdAt: new Date(Date.now() - 60 * 60000).toISOString(),
        photo: null
      }
    ],
    path: [
      { x: 350, y: 85, timestamp: Date.now() }
    ]
  },
  // Floor 2 - Cardiology
  {
    id: 'A011',
    name: 'Bed C-01',
    type: 'bed',
    floor: 2,
    room: 'C-305',
    x: 85,
    y: 200,
    status: 'in-use',
    batteryLevel: 76,
    lastSeen: new Date(Date.now() - 4 * 60000).toISOString(),
    maintenanceTickets: [],
    path: [
      { x: 85, y: 200, timestamp: Date.now() }
    ]
  },
  {
    id: 'A012',
    name: 'Wheelchair C-01',
    type: 'wheelchair',
    floor: 2,
    room: 'C-308',
    x: 480,
    y: 200,
    status: 'ready',
    batteryLevel: 89,
    lastSeen: new Date(Date.now() - 7 * 60000).toISOString(),
    maintenanceTickets: [],
    path: [
      { x: 480, y: 200, timestamp: Date.now() }
    ]
  },
  {
    id: 'A013',
    name: 'Pump C-01',
    type: 'pump',
    floor: 2,
    room: 'C-301',
    x: 100,
    y: 85,
    status: 'in-use',
    batteryLevel: 83,
    lastSeen: new Date(Date.now() - 1 * 60000).toISOString(),
    maintenanceTickets: [],
    path: [
      { x: 100, y: 85, timestamp: Date.now() }
    ]
  },
  {
    id: 'A014',
    name: 'Trolley C-01',
    type: 'trolley',
    floor: 2,
    room: 'C-302',
    x: 250,
    y: 90,
    status: 'to-clean',
    batteryLevel: 64,
    lastSeen: new Date(Date.now() - 25 * 60000).toISOString(),
    maintenanceTickets: [],
    path: [
      { x: 250, y: 90, timestamp: Date.now() }
    ]
  },
  {
    id: 'A015',
    name: 'Bed C-02',
    type: 'bed',
    floor: 2,
    room: 'C-306',
    x: 210,
    y: 205,
    status: 'ready',
    batteryLevel: 95,
    lastSeen: new Date(Date.now() - 6 * 60000).toISOString(),
    maintenanceTickets: [],
    path: [
      { x: 100, y: 85, timestamp: Date.now() - 7200000 },
      { x: 180, y: 150, timestamp: Date.now() - 3600000 },
      { x: 210, y: 205, timestamp: Date.now() }
    ]
  }
];

// User roles
export const USER_ROLES = [
  { value: 'nurse', label: 'Nurse' },
  { value: 'cleaning', label: 'Cleaning / Logistics' },
  { value: 'biomedical', label: 'Biomedical' },
  { value: 'admin', label: 'Administrator' }
];
